function calculateFontSizeScale() {
  let originalWidth = 1920
   if (window.matchMedia('(max-width: 750px)').matches) {
       originalWidth = 375;
    } else {
       originalWidth = 1920;
    }
    const targetWidth = window.innerWidth;
    const scaleRatio = targetWidth / originalWidth;
    document.body.style.setProperty('--custom-font-size', `${scaleRatio.toFixed(2)}`);
    requestAnimationFrame(calculateFontSizeScale)
}

calculateFontSizeScale()
window.addEventListener('resize', calculateFontSizeScale);
